import(/* webpackMode: "eager" */ "/app/app/analitics/page.tsx");
